import { render, staticRenderFns } from "./tablePesan.vue?vue&type=template&id=fc128f1e&scoped=true"
import script from "./tablePesan.vue?vue&type=script&lang=js"
export * from "./tablePesan.vue?vue&type=script&lang=js"
import style0 from "./tablePesan.vue?vue&type=style&index=0&id=fc128f1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc128f1e",
  null
  
)

export default component.exports